import React from "react";
import PropTypes from "prop-types";
import MarketingOptInCheckbox from "components/v3/marketing-opt-in-checkox/MarketingOptInCheckbox";
import isTerminalSubscriber from "utils/isTerminalSubscriber";
import styles from "./styles.module.scss";

const TermsAndPrivacyPolicy = ({ bloombergSiteUrl, country, onMarketingOptInChange, isOptedIn, isForAccountCreation }) => {
    return (
        <span className={ styles.textWrap }>
            <MarketingOptInCheckbox
                country={ country }
                onMarketingOptInChange={ onMarketingOptInChange }
                isChecked={ isOptedIn }
            />

            { getTerms(bloombergSiteUrl, isForAccountCreation, country) }
        </span>
    );
};

const getTerms = (bloombergSiteUrl, isForAccountCreation, country) => {
    const privacyPolicyLink = <a href={ `${ bloombergSiteUrl }/notices/privacy` } target="_blank" rel="noopener">Privacy Policy</a>;

    if (isForAccountCreation && country !== "US") {
        return (
            <span>
                By creating an account you agree to <a href={ `${ bloombergSiteUrl }/notices/tos` } target="_blank" rel="noopener">Bloomberg Terms</a> and { privacyPolicyLink }.
            </span>
        );
    }

    const tosLink = <a href={ `${ bloombergSiteUrl }/notices/tos` } target="_blank" rel="noopener">Terms of Service</a>;

    if (country === "US" || isTerminalSubscriber()) {
        /* eslint-disable max-len */
        return (
            <span>
                By submitting my information I agree to the { privacyPolicyLink } and { tosLink } and to receive offers and promotions from Bloomberg.
            </span>
        );
        /* eslint-enable max-len */
    }

    return (
        <span>By submitting my information I agree to the { privacyPolicyLink } and { tosLink }.</span>
    );
};

TermsAndPrivacyPolicy.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    onMarketingOptInChange: PropTypes.func.isRequired,
    isOptedIn: PropTypes.bool.isRequired,
    isForAccountCreation: PropTypes.bool.isRequired
};

export default TermsAndPrivacyPolicy;
